import { z } from 'zod';

import { BaseFlowBlockSchema, BlockType } from '../base/baseSchema.js';

export const GetSftpFileBlockConfigSchema = z.object({
  path: z.string(),
  server: z.string(),
});

export const GetSftpFileBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.GetSftpFile),
  config: GetSftpFileBlockConfigSchema,
});

export type GetSftpFileBlock = z.infer<typeof GetSftpFileBlockSchema>;
